import { render, staticRenderFns } from "./UserPerformanceOverview.vue?vue&type=template&id=5e758a05&"
import script from "./UserPerformanceOverview.vue?vue&type=script&lang=ts&"
export * from "./UserPerformanceOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports